module.exports = [{"city":"London","close":"16:30","country":"United Kingdom","id":"LSE","name":"London Stock Exchange","open":"08:00","tz":"Europe/London"}]


//////////////////
// WEBPACK FOOTER
// ./static/markets.json
// module id = nhqD
// module chunks = 1